import { render } from "./Size.vue?vue&type=template&id=55ab016e&scoped=true"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"

import "./Size.vue?vue&type=style&index=0&id=55ab016e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ab016e"]])

export default __exports__